const MOVEMENT_FILTERS = [
  { key: 0, label: "All Movement" },
  { key: 0.5, label: "0.5+" },
  { key: 1.0, label: "1.0+" },
];

const SORT_OPTIONS = [
  { key: "movement", label: "Largest Movement" },
  { key: "game_time", label: "Game Time" },
  { key: "league", label: "League" },
];

export const MovementFilters = ({ moversOnly, onMoversOnlyChange, minMovement, onMinMovementChange, sort, onSortChange }) => (
  <div className="flex flex-wrap items-center justify-between gap-3">
    <div data-testid="line-movement-movement-filters" className="flex flex-wrap gap-2">
      <button
        type="button"
        data-testid="line-movement-biggest-movers-tab"
        onClick={() => onMoversOnlyChange(!moversOnly)}
        title="Only games where the current total differs from the tracked open, largest move first"
        className={`rounded-full border px-3 py-1.5 font-mono text-xs uppercase tracking-wide transition-colors ${
          moversOnly ? "border-eb-accent bg-eb-accent/10 text-eb-accent" : "border-white/10 text-zinc-400 hover:text-zinc-200"
        }`}
      >
        Biggest Movers
      </button>
      {MOVEMENT_FILTERS.map((f) => (
        <button
          key={f.key}
          type="button"
          data-testid={`line-movement-movement-filter-${f.key}`}
          onClick={() => onMinMovementChange(f.key)}
          className={`rounded-full border px-3 py-1.5 font-mono text-xs uppercase tracking-wide transition-colors ${
            !moversOnly && minMovement === f.key ? "border-eb-accent bg-eb-accent/10 text-eb-accent" : "border-white/10 text-zinc-400 hover:text-zinc-200"
          }`}
        >
          {f.label}
        </button>
      ))}
    </div>
    <div data-testid="line-movement-sort-controls" className="flex items-center gap-2">
      <span className="font-mono text-[10px] uppercase tracking-wide text-zinc-500">Sort</span>
      {SORT_OPTIONS.map((s) => (
        <button
          key={s.key}
          type="button"
          data-testid={`line-movement-sort-${s.key}`}
          disabled={moversOnly}
          onClick={() => onSortChange(s.key)}
          className={`rounded-md border px-2.5 py-1 font-mono text-[11px] transition-colors ${
            moversOnly ? "cursor-not-allowed border-white/5 text-zinc-600" : sort === s.key ? "border-eb-accent text-eb-accent" : "border-white/10 text-zinc-500 hover:text-zinc-300"
          }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  </div>
);
